import { render, staticRenderFns } from "./PythonView.vue?vue&type=template&id=d5238b06&"
import script from "./PythonView.vue?vue&type=script&lang=js&"
export * from "./PythonView.vue?vue&type=script&lang=js&"
import style0 from "./PythonView.vue?vue&type=style&index=0&id=d5238b06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports